import {
  Children,
  PropsWithChildren,
  ReactNode,
  useCallback,
  useMemo,
} from "react";

type StringTemplateProps = {
  template: string;
  args?: ReactNode[];
  className?: string;
};

export const StringTemplate: React.FC<
  PropsWithChildren<StringTemplateProps>
> = ({ template, ...props }) => {
  const matchAll = useCallback((temp: string, regex: RegExp) => {
    let match;
    const matches: RegExpMatchArray[] = [];

    do {
      match = regex.exec(temp);
      if (match) {
        matches.push(match);
      }
    } while (match);

    return matches;
  }, []);

  const matches = useMemo(
    () => Array.from(matchAll(template, /{(\d+)}/g)),
    [template, matchAll],
  );

  if (matches.length > 0) {
    const args = props.args ?? Children.toArray(props.children);

    if (args == null || args.length === 0) {
      // eslint-disable-next-line no-console
      console.error(
        `StringTemplate '${template}' invalid args: required ${matches.length}, actual ${args?.length ?? 0}`,
      );

      return <span>{template}</span>;
    }

    const nodes: Array<ReactNode> = [];
    let lastIndex = 0;
    for (let i = 0; i < matches.length; i++) {
      const match = matches[i];
      const argIndex = parseInt(match![1]!, 10);
      nodes.push(template.substring(lastIndex, match!.index!));
      nodes.push(args[argIndex]);
      lastIndex = match!.index! + 3;
    }

    nodes.push(template.substr(lastIndex));

    return (
      <span className={props.className}>
        {nodes.map((x, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <span key={i}>{x}</span>
        ))}
      </span>
    );
  }

  return <span className={props.className}>{template}</span>;
};
